import panel from "../../../../assets/images/docs/panel.png";
import * as React from 'react';
export default {
  panel,
  React
};